import { Col, Row } from 'react-angle-dashboard-components'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { IQuoteFormData } from '../../QuoteForm'
import SelectCard from '../BasicQuoteInfo/SelectCard'
import { IVendorDTO } from '../../../../services/quote/dto'
import { convertStringToTitleCase } from '@angle/utils'

interface AddOnProgramSectionProps {
  filteredPlans: IVendorDTO[]
  programName: string
}

interface ISection {
  title: string
  description: string
  plans: IVendorDTO[]
  selectedPlans: ISelectedPlan[]
  append: (obj: object) => void
  remove: (num: number) => void
}

interface ISelectedPlan {
  id: number
}

const AddOnProgramSection = ({
  filteredPlans,
  programName
}: AddOnProgramSectionProps) => {
  const { control } = useFormContext<IQuoteFormData>()

  const {
    append: appendVendor,
    remove: removedVendor,
    fields: selectedVendors
  } = useFieldArray({
    control,
    name: `planInfo.step2.${programName}ProgramIds`
  })

  const section: ISection = {
    title: convertStringToTitleCase(programName),
    description: 'description',
    plans: filteredPlans,
    selectedPlans: selectedVendors,
    append: appendVendor,
    remove: removedVendor
  }

  const isADisabledProgramName = (programName: string) => {
    const disabledProgramNameList = ['Doctors on Demand Telehealth']
    if (disabledProgramNameList.includes(programName)) {
      return true
    }

    return false
  }

  const defaultIds = []

  for (let plan of filteredPlans) {
    if (isADisabledProgramName(plan.programName)) {
      defaultIds.push(plan.entryId)
    }
  }

  const idsToBeAppended = defaultIds.filter(
    (id) => !section.selectedPlans.some((plan) => plan.id === id)
  )

  for (let id of idsToBeAppended) {
    section.append({ id: id })
  }

  return (
    <Row key={section.title}>
      <Col>
        <Row>
          <Col>
            <div
              style={{
                fontWeight: 700,
                fontSize: 22,
                color: '#343A40'
              }}
            >
              {section.title}
            </div>
          </Col>
          <Col className="col-auto">{section.plans.length} options</Col>
        </Row>
        <hr />
        <Row className="my-3 gy-3">
          {section.plans.map(
            ({ entryId, programName, description, logoUrl }, index) => {
              const currentSelectedIndex = section.selectedPlans.findIndex(
                (v) => v.id === entryId
              )

              return (
                <Col key={entryId} className="col-auto">
                  <SelectCard
                    disabled={
                      isADisabledProgramName(programName) ||
                      isOtherPbmProgramSelected(section, entryId)
                    }
                    title={programName}
                    description={description}
                    image={logoUrl}
                    checked={currentSelectedIndex > -1}
                    onClick={(isSelected) => {
                      isSelected
                        ? section.append({ id: entryId })
                        : section.remove(currentSelectedIndex)
                    }}
                    checkGroupName={undefined}
                    checkType="checkbox"
                  />
                </Col>
              )
            }
          )}
        </Row>
      </Col>
    </Row>
  )
}

const isOtherPbmProgramSelected = (section: ISection, programId: number) => {
  if (section.title !== 'Pharmacy Programs') return false

  return section.selectedPlans.some((plan) => plan.id !== programId)
}

export default AddOnProgramSection
